import {React ,useState,useEffect,useRef}from 'react';
import { Button, TextField,FormControl,FormHelperText,InputLabel,Select,Typography,MenuItem} from '@mui/material';
import axios from "axios";
import configParam from '../../config';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import { useRecoilState} from 'recoil';
import { UserSettings } from '../../recoil/atoms';
import { useNavigate } from "react-router-dom";
import useMediaQuery from '@mui/material/useMediaQuery';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
const filter = createFilterOptions();
function AddUser({ open, onClose,onSave,selectedRowUserData: selectedRowUserDataProp,selectedRowData,selectedUserCardData,addedUsers,onHandleUser,onShowAlert,userDet,onHandleUserDateList,selectedUserYear}) {
   // Accept either prop name so an edit is never mistaken for a new user
   const selectedRowUserData = selectedRowUserDataProp || selectedRowData || null;
   const[role,setRole]=useState(null);
   const[name,setName]=useState('');
   const[email,setEmail]=useState('');
   const[sgid,setSgid]=useState('');
   const [plant, setPlant] = useState(null);
   const [businessdata, setBusinessData] = useState([]);
   const [business, setBusiness] = useState(null);
   const [plantdata, setPlantData] = useState([]);
   const [roledata, setRoleData] = useState([]);
   const [area, setArea] = useState(null);
   const [areadata, setAreaData] = useState([]);
   const [isEmailValid, setIsEmailValid] = useState(true);
  const [isFormValid, setIsFormValid] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isCursorInsideDialog, setIsCursorInsideDialog] = useState(false);
  const [selectedCreatedBy, setSelectedCreatedBy] = useState([]); // To store the selected options
const [selectAll, setSelectAll] = useState(false);
const [locationdata, setLocationData] = useState([]);
const [location, setLocation] = useState(null);
const[userDataSettings,setUserDataSettings]=useRecoilState(UserSettings)
const [userRole, setUserRole] = useState(null);
const [access_token,setAccessToken]=useState(localStorage.getItem("accesstoken"))
// const [selectedUserYear, setSelectedUserYear] = useState("");
const [currentaddedPlants, setCurrentAddedPlants] = useState([]);
const isMobileView = useMediaQuery('(max-width:1024px)');
const [department, setDepartment] = useState(null);
const [departmentData, setDepartmentData] = useState([]);
const [newDepartmentName, setNewDepartmentName] = useState("");
const [departmentError, setDepartmentError] = useState("");
const selectedLocationName = locationdata.find((option) => option.id === location)?.location;
const filteredPlantOptions = plantdata.filter((option) => {
  const optionLocationId = option.location_id ?? option.locationId ?? null;
  const optionLocationName = (option.location || '').toLowerCase();
  if (!location) return true;
  return optionLocationId === location || optionLocationName === (selectedLocationName || '').toLowerCase();
});
const navigate = useNavigate();
   const ApiURL =configParam.API_URL;
const normalizeText = (value) => (value || '').toString().trim().toLowerCase();
// Tracks which fields have already been filled from the row being edited (per open)
const prefilledRef = useRef({});
  
  const modalInputLabelStyle = {
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 500,
    color: '#000',
  };

console.log("selectedRowUserData",selectedRowUserData)
console.log("selectedUserCardData",selectedUserCardData)
console.log("departmentData",departmentData)
useEffect(() => {
  // if (!departmentData.length) return; // wait until departmentData is loaded

  let selectedDepartment = null;
  if (selectedRowUserData) {
    // If selectedRowData is present, it's an edit operation
    const selectedBusiness = businessdata.find((option) => normalizeText(option.business_name) === normalizeText(selectedRowUserData.business));
    const selectedPlant = plantdata.filter(item => (selectedRowUserData.plant || []).map(normalizeText).includes(normalizeText(item.plantName)))
    .map(item => item.id)
    const selectedRole = roledata.find((option) => normalizeText(option.role) === normalizeText(selectedRowUserData.role));
    const selectedLocation = locationdata.find((option) => normalizeText(option.location) === normalizeText(selectedRowUserData.location));
    if (selectedRowUserData.department) {
      selectedDepartment = departmentData.find(
        (option) =>
          option.departmentName.toLowerCase() ===
          selectedRowUserData.department.toLowerCase()
      );
    }

    if (selectedDepartment) {
      setDepartment(selectedDepartment);
      setNewDepartmentName("");
    } else {
      setDepartment(null); // ensure department cleared if null
      setNewDepartmentName("");
    }
    //  selectedDepartment = departmentData.find(
    //   (option) =>
    //     option.departmentName.toLowerCase() ===
    //     (selectedRowUserData.department
    //       ? selectedRowUserData.department.toLowerCase()
    //       : "")
    // );

    // if (selectedDepartment) {
    //   setDepartment(selectedDepartment);
    //   setNewDepartmentName(""); // ✅ reset newDepartmentName to match existing
    // }
 
    if (selectedBusiness) setBusiness(selectedBusiness.id);
   
    setSelectedCreatedBy(selectedPlant)
    const tabledataLength = plantdata.length;
    const plantLength = selectedRowUserData.plant.length;
    if(tabledataLength===plantLength){
      // setSelectAll(true)
    }
    
    
    if (selectedRole) setRole(selectedRole.id);
    if (selectedLocation) setLocation(selectedLocation.id);

    // Always set the other state variables
    setSgid(selectedRowUserData.sgid);
    setName(selectedRowUserData.name);
    setEmail(selectedRowUserData.email);
  } 


  else if (selectedUserCardData) {
   
    const selectedBusiness = businessdata.find((option) => normalizeText(option.business_name) === normalizeText(selectedUserCardData.business_name));
    // const selectedPlant = plantdata.filter(item => selectedUserCardData.plant_name.includes(item.plantName.toUpperCase()))
    // .map(item => item.id)
    // console.log("selectedPlant",selectedPlant)
    const selectedPlant = plantdata.filter(item => 
      (selectedUserCardData.plant_name || []).map(normalizeText).includes(normalizeText(item.plantName))
  ).map(item => item.id);
 
  
    const selectedRole = roledata.find((option) => normalizeText(option.role) === normalizeText(selectedUserCardData.role_name));
    const selectedLocation = locationdata.find((option) => normalizeText(option.location) === normalizeText(selectedUserCardData.location));
  if (selectedUserCardData.department) {
      selectedDepartment = departmentData.find(
        (option) =>
          option.departmentName.toLowerCase() ===
          selectedUserCardData.department.toLowerCase()
      );
    }

    if (selectedDepartment) {
      setDepartment(selectedDepartment);
      setNewDepartmentName("");
    } else {
      setDepartment(null);
      setNewDepartmentName("");
    }
  // selectedDepartment = departmentData.find(
  //     (option) =>
  //       option.departmentName.toLowerCase() ===
  //       (selectedUserCardData.department
  //         ? selectedUserCardData.department.toLowerCase()
  //         : "")
  //   );

  //    if (selectedDepartment) {
  //     setDepartment(selectedDepartment);
  //     setNewDepartmentName(""); // ✅ reset newDepartmentName to match existing
  //   }

    // Make sure the state updates are correctly applied
    if (selectedBusiness) setBusiness(selectedBusiness.id);
    setSelectedCreatedBy(selectedPlant)
    const tabledataLength = plantdata.length;
    const plantLength = selectedUserCardData.plant_name.length;
    if(tabledataLength===plantLength){
      // setSelectAll(true)
    }
    if (selectedRole) setRole(selectedRole.id);
    if (selectedLocation) setLocation(selectedLocation.id);
    // Always set the other state variables
    setSgid(selectedUserCardData.sgid);
    setName(selectedUserCardData.name);
    setEmail(selectedUserCardData.email);
  }
  else {
    // If selectedRowData and selectedCardData are null, it's an add operation
  
    setBusiness(null);
    setPlant(null);
    setRole(null);
    setArea('');
    setSgid('');
    setName('');
    setEmail('');
    setIsEmailValid(true);
    setSelectedCreatedBy([])
    setLocation(null);
    setDepartment(null);
    getPlantDetails()
  }
}, [selectedRowUserData, selectedUserCardData, open, departmentData]);
useEffect(() => {
  prefilledRef.current = {};
}, [open, selectedRowUserData, selectedUserCardData]);

useEffect(() => {
  // Edit mode: the dropdown lists load after the dialog opens, so fill each field
  // as soon as its list is available (only once per open, so user changes are kept).
  if (!open) return;
  const isRow = !!selectedRowUserData;
  const source = selectedRowUserData || selectedUserCardData;
  if (!source) return;
  const done = prefilledRef.current;

  if (!done.business && businessdata.length) {
    const found = businessdata.find((option) => normalizeText(option.business_name) === normalizeText(isRow ? source.business : source.business_name));
    if (found) { setBusiness(found.id); done.business = true; }
  }
  if (!done.role && roledata.length) {
    const found = roledata.find((option) => normalizeText(option.role) === normalizeText(isRow ? source.role : source.role_name));
    if (found) { setRole(found.id); done.role = true; }
  }
  if (!done.location && locationdata.length) {
    const found = locationdata.find((option) => normalizeText(option.location) === normalizeText(source.location));
    if (found) { setLocation(found.id); done.location = true; }
  }
  if (!done.plant && plantdata.length) {
    const names = ((isRow ? source.plant : source.plant_name) || []).map(normalizeText);
    const ids = plantdata.filter((item) => names.includes(normalizeText(item.plantName))).map((item) => item.id);
    if (ids.length) { setSelectedCreatedBy(ids); done.plant = true; }
  }
}, [open, selectedRowUserData, selectedUserCardData, businessdata, roledata, locationdata, plantdata]);

  // useEffect(() => {
  //   let data = localStorage.getItem("user");
  //   let User = JSON.parse(data);
  //   setUserDet(User);
  // }, []);
useEffect(() => {
  // Function to check for accessToken changes
  const handleAccessTokenChange = () => {
    const storedAccessToken = localStorage.getItem("accesstoken");
    if (storedAccessToken !== access_token) {
      setAccessToken(storedAccessToken);
    }
  };

  // Listen for storage events (for cross-tab changes)
  window.addEventListener("storage", handleAccessTokenChange);

  // Check for changes every second (for same-tab changes)
  const interval = setInterval(handleAccessTokenChange, 1000);

  // Cleanup listeners and interval on component unmount
  return () => {
    window.removeEventListener("storage", handleAccessTokenChange);
    clearInterval(interval);
  };
}, [access_token]); // Dependency on accessToken

useEffect(() => {
  // (Re)load the dropdown lists whenever the dialog opens or the access token changes,
  // so they are never left empty by an early / failed first request.
  let User = null;
  try {
    User = JSON.parse(localStorage.getItem("user"));
  } catch (e) {
    User = null;
  }

  if(Number(User?.role_id)===1){
    getAdminRoleDetails()
  } else {
    getRoleDetails();
  }
  getBusinessDetails();
  getLocationDetails();
  getAreaDetails();
  getPlantDetails();
  getDepartmentDetails()
  }, [open, access_token]);
const getRoleDetails = () => {
  let url = ApiURL + '/select_role';
  axios.get(url,{
    headers: {
      Authorization: `Bearer ${access_token}`,
     
    }
  }
).then((response) => {
    setRoleData(response.data.map(item => ({
      ...item,
      role: (item.role||"").charAt(0).toUpperCase()+ (item.role||"").slice(1)
    })));
  }).catch((error) => {
    setRoleData([]);
  });
  };
  const getAdminRoleDetails = () => {
 
    let url = ApiURL +'/select_admin_role'
    axios.get(url,{
      headers: {
        Authorization: `Bearer ${access_token}`,
        
      }
    }
).then((response) => {
      setRoleData(response.data);
    }).catch((error) => {
      setRoleData([]);
    });
    };
  const getLocationDetails = () => {
    let url = ApiURL + '/show_location';
    axios.get(url,{
      headers: {
        Authorization: `Bearer ${access_token}`,
       
      }
    }
).then((response) => {
      setLocationData(response.data);
    }).catch((error) => {
      setLocationData([]);
    });
  };
  const getBusinessDetails = () => {
    let url = ApiURL + '/show_business';
    axios.get(url,{
      headers: {
        Authorization: `Bearer ${access_token}`,
       
      }
    }
).then((response) => {
      setBusinessData(response.data);
    }).catch((error) => {
      setBusinessData([]);
    });
    };
  const getAreaDetails = () => {
    let url = ApiURL + '/select_area';
    axios.get(url,{
      headers: {
        Authorization: `Bearer ${access_token}`,
        
      }
    }
).then((response) => {
      setAreaData(response.data);
    }).catch((error) => {
      setAreaData([]);
    });
    };
    const getPlantDetails = () => {
      let url = ApiURL + '/show_plant';
      axios.get(url,{
        headers: {
          Authorization: `Bearer ${access_token}`,
        
        }
      }
  ).then((response) => {
        setPlantData(response.data);
      }).catch((error) => {
        setPlantData([]);
      });
      };
const getDepartmentDetails = () => {
  let url = ApiURL + '/get_departments';
  axios
    .get(url, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    })
    .then((response) => {
      setDepartmentData(response.data);
    })
    .catch((error) => {
      setDepartmentData([]);
    });
};

  
const handleClose = () => {
  setRole(null);
  setName('');
  setEmail('');
  setSgid('');
  setPlant(null);
  setBusiness(null);
  setArea('');
  setIsEmailValid(true);
  setIsFormValid(false);
  setIsFormSubmitted(false);
  setSelectedCreatedBy([]);
  setLocation(null);
  setDepartment(null);
  setNewDepartmentName('');
  setDepartmentError('');
  setSelectAll(false);
  onClose();
};
const validateEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};
const validateSGID = (sgid) => {
  const sgidRegex = /^[A-Za-z][A-Za-z0-9]*(-[A-Za-z0-9]+)?$/;
  return sgidRegex.test(sgid);
};
const validateName = (name) => {
  const nameRegex = /^[A-Za-z. ]+$/; // Allows letters and spaces
  return nameRegex.test(name);
};
const validateForm = () => {
  let valid = true;
  if (!sgid || !name || !email || !role || !business || !location || !department || selectedCreatedBy.length === 0) {
    valid = false;
  }
  if (!sgid) {
    valid = false;
  } else if (!validateSGID(sgid)) {
    valid = false;
  }
  if (!name) {
    valid = false;
  } else if (!validateName(name)) {
    valid = false;
  }
  if (!email) {
    valid = false;
  } else if (!validateEmail(email)) {
    valid = false;
  }
  if (!role) {
    setRole(null);
    valid = false;
  }
  if (!business) {
    setBusiness(null);
    valid = false;
  }
  if (!location) {
    setLocation(null);
    valid = false;
  }
  if (!department) {
    setDepartmentError('Please select or add department.');
    valid = false;
  } else {
    setDepartmentError('');
  }
  if (selectedCreatedBy.length === 0) {
    valid = false;
  }
  setIsFormValid(valid);
  return valid;
};

const handleRoleChange = (event, newValue) => {
  setRole(newValue?newValue.id:null);
  };
  const handleBusinessChange = (event,newValue) => {
    setBusiness(newValue?newValue.id:null);
    setDepartmentError('');
        };
 const handleLocationChange = (event, newValue) => {
          const nextLocationId = newValue ? newValue.id : null;
          setLocation(nextLocationId);
          setSelectedCreatedBy((prev) => prev.filter((plantId) => !!filteredPlantOptions.find((option) => option.id === plantId)));
          setDepartmentError('');
          if (!nextLocationId) {
            setSelectedCreatedBy([]);
          }
        };
 
  const handleEmailChange = (event) => {
    const newEmail = event.target.value;
        setEmail(newEmail);
        setIsEmailValid(validateEmail(newEmail));
          };
 const handleNameChange = (event) => {
    const newName = event.target.value;
    setName(newName);
          };
  const handleSgidChange = (event) => {
    const sgidValue = event.target.value;
    setSgid(sgidValue);
          };  
      
 const saveOrUpdateDepartment = async (department, newDepartmentName, access_token) => {
  // Case 1: New department entered → create
  if (newDepartmentName && !department?.id) {
    const res = await axios.post(
      ApiURL + '/create_department',
      { departmentName: newDepartmentName },
      { headers: { Authorization: `Bearer ${access_token}` } }
    );
     const newDept = { id: res.data.id, departmentName: newDepartmentName };
    setDepartmentData((prev) => [...prev, newDept]); // Add new department to state
    setDepartment(newDept); // Set the new department in the input
    return res.data.id;
    // return res.data.id;
  }

  // Case 2: Existing department renamed → update
  if (department?.id && newDepartmentName && newDepartmentName !== department.departmentName) {
    await axios.post(
      ApiURL + '/update_department',
      { id: department.id, departmentName: newDepartmentName },
      { headers: { Authorization: `Bearer ${access_token}` } }
    );
    setDepartmentData((prev) =>
      prev.map((d) =>
        d.id === department.id ? { ...d, departmentName: newDepartmentName } : d
      )
    );
    setDepartment({ ...department, departmentName: newDepartmentName }); // Update input
    return department.id;
    // return department.id;
  }

  // Case 3: Existing department unchanged → just return id
  if (department?.id) {
    return department.id;
  }

  return null;
};


         
  const handleSave = async() => {
    setIsFormSubmitted(true)
    const isFormValid = validateForm();
   
    if(isFormValid){
      const userId = selectedRowUserData?.id || selectedUserCardData?.id || null;

     // ✅ department handling
    
    let departmentId = null;
    

  try {
    departmentId = await saveOrUpdateDepartment(department, newDepartmentName, access_token);
  } catch (err) {
    alert("Failed to save department");
    console.error(err);
    return;
  }
    
        const newUser = userId?{
          id:  userId ,
          sgid,
          name,
          email,
          role: role? role : '',
          business:business?business:'',
          location:location?location:'',
           
          plant:  selectedCreatedBy ? selectedCreatedBy: '',
          // department_id: departmentId || null,
          department_id: departmentId,
          userdet:userDet.name
          }
          :{
            sgid,
            name,
            email,
            role: role? role : '',
            business:business?business:'',
            location:location?location:'',
            plant: selectedCreatedBy ? selectedCreatedBy: '',
            //  department_id: departmentId || null,
            department_id: departmentId,
            userdet:userDet.name
          };
          const isYearSelected = selectedUserYear !== ""; 
    if(userId){
      axios
      .post(ApiURL + '/update_users', newUser,{
        headers: {
          Authorization: `Bearer ${access_token}`,
          
        }
      }
  ) // Replace '/create_area' with your backend API endpoint to save the area data
      .then((response) => {
       
      
        let data = localStorage.getItem("user");
        let User = JSON.parse(data)
        const userset=JSON.parse(response.config.data)
        
        if(User.id===userset.id){
          User.role_id=userset.role;
          localStorage.setItem("user", JSON.stringify(User));
          if(userset.role===2){
            setUserDataSettings('2')
            onSave(newUser);
            if (!isMobileView) {
              if (isYearSelected) {
                  onHandleUserDateList(selectedUserYear);
              } else {
                  onHandleUser();
              }
          } else {
              onHandleUser();
          }
          // onHandleUser();
          onShowAlert('User updated successfully');
          navigate('/view')
          }
          else if(userset.role===1){
            setUserDataSettings('2')
            onSave(newUser);
            if (!isMobileView) {
              if (isYearSelected) {
                  onHandleUserDateList(selectedUserYear);
              } else {
                  onHandleUser();
              }
          } else {
              onHandleUser();
          }
          // onHandleUser();
          onShowAlert('User updated successfully');
          getAdminRoleDetails();
          }
          else{
            setUserDataSettings('2')
            onSave(newUser);
          // onHandleUser();
          if (!isMobileView) {
            if (isYearSelected) {
                onHandleUserDateList(selectedUserYear);
            } else {
                onHandleUser();
            }
        } else {
            onHandleUser();
        }
          onShowAlert('User updated successfully');
          }
         
        }
        else{
          if (!isMobileView) {
            if (isYearSelected) {
                onHandleUserDateList(selectedUserYear);
            } else {
                onHandleUser();
            }
        } else {
            onHandleUser();
        }
          onSave(newUser);
        // onHandleUser();
        onShowAlert('User updated successfully');
        }
        
      })
      .catch((error) => {
       
        // Handle error
        console.error('Failed to save user:', error);
      });
     
    }else{
      axios      
      .post(ApiURL + '/create_user', newUser,{
        headers: {
          Authorization: `Bearer ${access_token}`,
         
        }
      }
  ) // Replace '/save_area' with your backend API endpoint to save the area data      
      .then((response) => {          
       onSave(newUser);
       if (!isMobileView) {
        if (isYearSelected) {
            onHandleUserDateList(selectedUserYear);
        } else {
            onHandleUser();
        }
    } else {
  
        onHandleUser();
    }
           
       onShowAlert('User created successfully');
     })      
     .catch((error) => {      
       // Handle error    
       if (error.response && error.response.status === 409) {
        // SGID already exists, display error message
        alert('User already exists with the same SGID.');
      } else {
        // Other errors, log and display generic error message
        console.error('Failed to create user:', error);
        alert('Failed to create user. Please try again later.');
      }  
      //  console.error('Failed to save user:', error);      
     });
    }
   
  }
  setSelectAll(false)
  
 
};
const handleSelectAllChange = (event) => {
  if (event.target.checked) {
  
    setSelectedCreatedBy([...plantdata.map((option) => option.id)]);
    
  } else {
    
    setSelectedCreatedBy([]);
  }
  setSelectAll(event.target.checked);

};


const handleUserOptionChange = (event, option) => {
  if (!selectAll) {
  const optionId = option.id; // Assuming that each option has an 'id' property

  if (event.target.checked) {
    
    setSelectedCreatedBy((prevSelected) => [...prevSelected, optionId]);
   
  } else {
    

    setSelectedCreatedBy((prevSelected) =>
      prevSelected.filter((selectedOption) => selectedOption !== optionId)
    );
  }
 
}
};
const renderSelectedOptions = (selected) => {
  if (selected.includes("selectAll")) {
    return "Select All";
  }
  const selectedValues = selected.map((id) =>
    plantdata.find((option) => option.id === id).plantName.toUpperCase()
  );
  return selectedValues.join(", ");
};
console.log("department",department)
return (
<div >
 <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">

 <DialogTitle style={{  paddingBottom: 0 }}>User Details</DialogTitle>
 <DialogContent  className={`dialog-content ${isCursorInsideDialog ? 'show-scroll' : ''}`}

     

  onMouseEnter={() => {

    setIsCursorInsideDialog(true);

  }}

  onMouseLeave={() => {

    setIsCursorInsideDialog(false);

  }}>
 <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#334155', mb: 0.5 }}>SGID<span style={{ color: 'red' }}> *</span></Typography>
<TextField
          name="sgid"
          value={sgid}
          onChange={handleSgidChange}
          size="small"
          className="input-nis"
          fullWidth
          style={{ marginBottom:16}}
          disabled={!!(selectedRowUserData || selectedUserCardData)}
          error={isFormSubmitted && (!sgid || !validateSGID(sgid))}
          helperText={isFormSubmitted && (!sgid ? 'Please enter SGID.' : !validateSGID(sgid) ? 'Enter valid SGID.' : '')}
          />
          
<Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#334155', mb: 0.5, mt: 1.5 }}>Name<span style={{ color: 'red' }}> *</span></Typography>
<TextField  name="name" value={name} onChange={handleNameChange}size="small"  className="input-nis" fullWidth  style={{ marginBottom:16}} error={isFormSubmitted && (!name || !validateName(name))} helperText={isFormSubmitted && (!name ? 'Please enter name.' : !validateName(name) ? 'Enter name with letters only.' : '')} />
<Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#334155', mb: 0.5, mt: 1.5 }}>Email Id<span style={{ color: 'red' }}> *</span></Typography>
<TextField
             name="emailId"
            value={email}
            onChange={handleEmailChange}
            size="small"
            className="input-nis"
            fullWidth
            style={{ marginBottom:16}}
            error={isFormSubmitted && (!email || !validateEmail(email))}
            helperText={isFormSubmitted && (!email ? 'Please enter email.' : !validateEmail(email) ? 'Invalid email format.' : '')}/>
   
<Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#334155', mb: 0.5, mt: 1.5 }}>Role<span style={{ color: 'red' }}> *</span></Typography>
<Autocomplete
        className="autocomplete-nis"
        size="small"
        options={roledata}
        getOptionLabel={(newValue) => newValue.role}
        onChange={handleRoleChange}
        value={roledata.find((option)=>option.id===role)||null}
        renderInput={(params) => <TextField {...params} fullWidth error={isFormSubmitted && !role} helperText={isFormSubmitted && !role ? 'Please select Role' : ''} />}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        style={{ marginBottom:16}}
        />
        <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#334155', mb: 0.5, mt: 1.5 }}>Business<span style={{ color: 'red' }}> *</span></Typography>
<Autocomplete
       className="autocomplete-nis"
       size="small"
        options={businessdata}
        getOptionLabel={(newValue) =>newValue.business_name.toUpperCase()}
        onChange={handleBusinessChange}
        value={businessdata.find((option)=>option.id===business)||null}
        renderInput={(params) => <TextField {...params} fullWidth error={isFormSubmitted && !business} helperText={isFormSubmitted && !business ? 'Please select Business' : ''} />}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        style={{ marginBottom:16}}
        />
         <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#334155', mb: 0.5, mt: 1.5 }}>Location<span style={{ color: 'red' }}> *</span></Typography>
        <Autocomplete
          className="autocomplete-nis"
          size="small"
          options={locationdata}
          getOptionLabel={(newValue) => newValue.location.toUpperCase()}

          onChange={handleLocationChange}
          value={locationdata.find((option) => option.id === location) || null}
          renderInput={(params) => <TextField {...params} fullWidth error={isFormSubmitted && !location} helperText={isFormSubmitted && !location ? 'Please select Location' : ''} />}
          selectOnFocus
          clearOnBlur
          handleHomeEndKeys
          style={{ marginBottom:16}}
        />
  <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#334155', mb: 0.5, mt: 1.5 }}>Plant<span style={{ color: 'red' }}> *</span></Typography>
            <FormControl fullWidth style={{ marginBottom: 16 }}>
      <Select
        multiple
        value={selectedCreatedBy}
        onChange={handleUserOptionChange}
        className='select-nis'
        size="small"
        renderValue={renderSelectedOptions}
        error={isFormSubmitted && selectedCreatedBy.length === 0}
      >
        <MenuItem key="selectAll" value="selectAll">
          <Checkbox checked={selectAll} onChange={handleSelectAllChange} />
          <ListItemText primary="Select All" />
        </MenuItem>
        {filteredPlantOptions.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            <Checkbox checked={selectedCreatedBy.includes(option.id)} 
             onChange={(event) => handleUserOptionChange(event, option)}/>
            
            <ListItemText primary={option.plantName.toUpperCase()} />
          </MenuItem>
        ))}
      </Select>
      {isFormSubmitted && selectedCreatedBy.length === 0 && (
        <FormHelperText error>Please select Plant</FormHelperText>
      )}
    </FormControl>

    <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#334155', mb: 0.5, mt: 1.5 }}>Department<span style={{ color: 'red' }}> *</span></Typography> 
<Autocomplete
  className="autocomplete-nis"
  size="small"
  freeSolo
  value={department}
  onChange={(event, newValue) => {
    setDepartmentError("");
    if (typeof newValue === "string") {
      if (department?.id) {
        setDepartment({ ...department, departmentName: newValue });
        setNewDepartmentName(newValue);
      } else {
        setDepartment({ departmentName: newValue });
        setNewDepartmentName(newValue);
      }
    } else if (newValue && newValue.inputValue) {
      if (department?.id) {
        setNewDepartmentName(newValue.inputValue);
      } else {
        setDepartment({ departmentName: newValue.inputValue });
        setNewDepartmentName(newValue.inputValue);
      }
    } else {
      setDepartment(newValue);
      setNewDepartmentName("");
    }
  }}
  filterOptions={(options, params) => {
    const filtered = filter(options, params);

    if (params.inputValue !== '') {
      filtered.push({
        inputValue: params.inputValue,
        departmentName: `Add "${params.inputValue}"`,
      });
    }
    return filtered;
  }}
  selectOnFocus
  clearOnBlur
  handleHomeEndKeys
  options={departmentData}
  getOptionLabel={(option) => {
    if (typeof option === 'string') return option;
    if (option.inputValue) return option.inputValue;
    return option.departmentName;
  }}
  renderOption={(props, option) => (
    <li {...props}>
      {option.inputValue ? `Add "${option.inputValue}"` : option.departmentName}
    </li>
  )}
  renderInput={(params) => (
    <TextField {...params} 
    fullWidth size="small"
    error={isFormSubmitted && !department}
      helperText={isFormSubmitted && !department ? 'Please select Department' : ''}
     />
  )}
  disabled={userDet.role_id !== 3}
/>


 {/* <InputLabel style={modalInputLabelStyle}>Department</InputLabel>

<Autocomplete
  className="autocomplete-nis"
  size="small"
  freeSolo
  value={department}
  onChange={(event, newValue) => {
    if (newValue && newValue.inputValue) {
      // New department entered
      setDepartment({ departmentName: newValue.inputValue });
      setNewDepartmentName(newValue.inputValue);
    } else {
      // Existing department chosen
      setDepartment(newValue);
      setNewDepartmentName("");
    }
  }}
  filterOptions={(options, params) => {
    const filtered = filter(options, params);

    if (params.inputValue !== '') {
      filtered.push({
        inputValue: params.inputValue,
        departmentName: `Add "${params.inputValue}"`,
      });
    }
    return filtered;
  }}
  selectOnFocus
  clearOnBlur
  handleHomeEndKeys
  options={departmentData}
  getOptionLabel={(option) => {
    if (typeof option === 'string') return option;
    if (option.inputValue) return option.inputValue;
    return option.departmentName;
  }}
  renderOption={(props, option) => (
    <li {...props}>
      {option.inputValue ? `Add "${option.inputValue}"` : option.departmentName}
    </li>
  )}
  renderInput={(params) => (
    <TextField {...params} fullWidth size="small" />
  )}
/> */}




  </DialogContent>

<DialogActions style={{ borderTop: '1px solid #f5f5f5', padding: '10px 20px' }}>
<Button variant="outlined"  onClick={handleClose} style={{  color:'#203468',marginRight: '8px',borderColor: '#203468'}}>
Cancel
</Button>
<Button variant="contained" style={{backgroundColor:'#203468'}} onClick={handleSave}>
Save
</Button>
</DialogActions>

</Dialog>
</div>
);
}
export default AddUser;